import { Chip } from "@mui/material";

type Props = {
  count?: number;
};

const NavigationListChip = ({ count }: Props) => {
  if (!count || count < 0) return null;

  return (
    <Chip
      sx={{
        height: "20px",
        marginBottom: "0px",
        marginRight: "0px",
      }}
      label={count}
      variant="filled"
      color="primary"
    />
  );
};

export default NavigationListChip;
